import { c as _c } from "react/compiler-runtime";
import { Divider } from "@flat-ui";

/** Simple vertical divider between action buttons */
export function SphereActionDivider() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Divider orientation="vertical" flexItem={true} sx={{
      height: "17px",
      alignSelf: "center",
      marginX: "4px",
      paddingY: "6px"
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}